export const Step1Selectors = {
    FORM:    "#step1_form",
    CLEAR_ALL_PRODUCTS: '#clear_all',
    PRODUCT: {
        CONTAINER: '.js_product_row',
        REMOVE:    '.js_product_remove',
        QUANTITY:  '.js_product_quantity',
        TOTAL:     '.js_product_total',
        QUANTITY_CONTROL_INCREASE: '.product-input-control-plus',
        QUANTITY_CONTROL_DECREASE: '.product-input-control-minus',
    },
    OFFER: {
        OFFER_CLEAR_ALL: '#clear_all_offer',
        OFFER_CONTAINER: '.js_product_offer_row',
        OFFER_REMOVE   : '.js_product_offer_remove',
        OFFER_QUANTITY : '.js_product_offer_quantity',
        OFFER_TOTAL    : '.js_product_offer_total',
        OFFER_QUANTITY_CONTROL_INCREASE: '.offer-input-control-plus',
        OFFER_QUANTITY_CONTROL_DECREASE: '.offer-input-control-minus',
    },
    PRODUCT_AND_OFFER_CART: {
        CONTAINER: '.js_product_row_cart_and_offer',
        TOTAL: '.js_product_cart_and_offer_total',
    },
    SUMMARY_PANEL: {
        TOTAL_QUANTITIES: '.total-quantities',
        PRODS_QUANTITY  : '#products-quantity',
        TOTAL           : '.total-price',
    },
    DELIVERY_BAR: {
        DELIVERY_CONTAINER: '.cart-delivery',
        BAR: '.js_cart_delivery_value_bar',
        START: '.js_cart_delivery_value_start',
        END: '.js_cart_delivery_value_end',
        MISSING_VALUE: '.js_cart_delivery_value',
        MISSING_VALUE_TEXT: {
            NOT_YET: ".js_cart_delivery_missing_value_text__not_yet",
            FULFILLED: ".js_cart_delivery_missing_value_text__fulfilled"

        }
    }
}

export const Step1Selectors = {
    FORM:    "#step1_form",
    CLEAR_ALL_PRODUCTS: '#clear_all',
    PRODUCT: {
        CONTAINER: '.js_product_row',
        REMOVE:    '.js_product_remove',
        QUANTITY:  '.js_product_quantity',
        TOTAL:     '.js_product_total',
        QUANTITY_CONTROL_INCREASE: '.product-input-control-plus',
        QUANTITY_CONTROL_DECREASE: '.product-input-control-minus',
    },
    OFFER: {
        OFFER_CLEAR_ALL: '#clear_all_offer',
        OFFER_CONTAINER: '.js_product_offer_row',
        OFFER_REMOVE   : '.js_product_offer_remove',
        OFFER_QUANTITY : '.js_product_offer_quantity',
        OFFER_TOTAL    : '.js_product_offer_total',
        OFFER_QUANTITY_CONTROL_INCREASE: '.offer-input-control-plus',
        OFFER_QUANTITY_CONTROL_DECREASE: '.offer-input-control-minus',
    },
    PRODUCT_AND_OFFER_CART: {
        CONTAINER: '.js_product_row_cart_and_offer',
        TOTAL: '.js_product_cart_and_offer_total',
    },
    SUMMARY_PANEL: {
        TOTAL_QUANTITIES: '.total-quantities',
        PRODS_QUANTITY  : '#products-quantity',
        TOTAL           : '.total-price',
    },
    DELIVERY_BAR: {
        DELIVERY_CONTAINER: '.cart-delivery',
        BAR: '.js_cart_delivery_value_bar',
        START: '.js_cart_delivery_value_start',
        END: '.js_cart_delivery_value_end',
        MISSING_VALUE: '.js_cart_delivery_value',
        MISSING_VALUE_TEXT: {
            NOT_YET: ".js_cart_delivery_missing_value_text__not_yet",
            FULFILLED: ".js_cart_delivery_missing_value_text__fulfilled"

        }
    }
}

